<template>
  <div class="text-center mb-4 d-print-none">
    <div class="mb-3">
      {{ $t('gsg.logo.alt-text') }}
    </div>
  </div>
</template>
